import React from 'react';

function PageLayout({ title, subtitle, children }) {
  return (
    <section className="devices">
      <div className="container">
        <h1>{title}</h1>
        <p className="small-text">{subtitle}</p>
        {children}
      </div>
    </section>
  );
}

export default PageLayout;